const convertTextsToCSS = (texts) => ({
    '--texts-positive': texts.positive,
    '--texts-negative': texts.negative,
    '--texts-base': texts.base,
    '--texts-tint-1': texts.tint1,
    '--texts-tint-2': texts.tint2,
    '--texts-tint-3': texts.tint3,
});
const convertTextsToObject = (texts) => ({
    textsPositive: texts.positive,
    textsNegative: texts.negative,
    textsBase: texts.base,
    textsTint1: texts.tint1,
    textsTint2: texts.tint2,
    textsTint3: texts.tint3,
});
const Texts = {
    positive: 'var(--texts-positive)',
    negative: 'var(--texts-negative)',
    base: 'var(--texts-base)',
    tint1: 'var(--texts-tint-1)',
    tint2: 'var(--texts-tint-2)',
    tint3: 'var(--texts-tint-3)',
};

export { Texts, convertTextsToCSS, convertTextsToObject };
